<div>
  <label *ngIf="isDisplayLable" for="dropdown">Chọn một giá trị:</label>
  <select id="dropdown" [ngModel]="selectedValue" (ngModelChange)="onChange($event)">
    <option *ngFor="let option of options" [value]="option">{{ option }}</option>
  </select>
</div>